import axios from 'axios';
import moment from 'moment';
import React, { Component } from 'react';
import { Accordion, Button, Card, FormControl, Modal, OverlayTrigger, Popover, Spinner, Tooltip } from 'react-bootstrap';
import Magnifier from 'react-magnifier';
import DatePicker from '../../../../components/common/DatePicker';
import AxiosConfig from '../../../../utilities/AxiosConfig';
import { shouldAllowAccess } from '../../../../utilities/helper';
import snackBar from '../../../../utilities/snackBar/SnackBar';
//@ts-ignore
import DocUploader from '../../FleetUtilities/DocUploader/DocUploader';
import NewMaintenance from './NewMaintenance/NewMaintenance';
import './VehicleMaintenance.css'
import reggie from 'src/utilities/Reggie';
import DocViewer from '../../FleetUtilities/DocViewer/DocViewer';
import IconBuilder from 'src/utilities/iconBuilder/IconBuilder';
interface VehicleMaintenanceProps {
    userId: any
    details: any
    fleetReference: any
    maintenances: any
    refreshAll: Function
    updateNotiication?: Function
}

type VehicleMaintenanceTypes = {
    expandLess: number
    maintenanceTypeList: Array<any>
    isChrome: boolean
    maintenanceId: string
    maintenanceDex: number
    maintenanceDate: any
    vehicleInfoId: number
    Mileage: number
    PerformedBy: string
    PurchaseOrderNumber: string
    Comments: string
    eventType: string
    attachments: boolean
    maintenanceReceipts: Array<any>
    newMaintenance: boolean
    photoNag: boolean
    loading: boolean
    fullScreen: boolean
    fullScreenIndex: number
    zoomFactor: number
    canZoom: boolean
    confirmDelete: boolean
    confirmReject: boolean
    confirmApprove: boolean
    ReviewedDate: string | null
    ReviewedBy: string | null
    ReviewStatusTypeId: number | null
    ReviewComments: string | null
    ReviewerName: string | null
    editReview: boolean
    viewFile: boolean
    filePath: string | null
    fileName: string | null
    openMaintenance: any
}

class VehicleMaintenance extends Component<VehicleMaintenanceProps, VehicleMaintenanceTypes>{

    serviceParams: Array<any> = []
    postParams: any
    wrapperRef: any;
    fullScreenIndex = 0
    imageExtensions = ["jpg", "jpeg", "png", "svg", "ico", "gif", "apng"]

    storageLocation = process.env.REACT_APP_FLEET_MAINTENANCE_FILES_STORAGE_LOCATION
    containerName = process.env.REACT_APP_FLEET_MAINTENANCE_FILES_CONTAINER_NAME
    fileStoreLocationId = process.env.REACT_APP_FLEET_MAINTENANCE_FILES_FILE_STORE_LOCATION_ID

    constructor(props: any) {
        super(props)
        this.state = {
            expandLess: -1,
            maintenanceTypeList: [],
            isChrome: true,
            maintenanceId: "",
            vehicleInfoId: -1,
            maintenanceDex: 0,
            maintenanceDate: Date.now(),
            Mileage: 0,
            eventType: "",
            PerformedBy: "",
            PurchaseOrderNumber: "",
            Comments: "",
            attachments: false,
            maintenanceReceipts: [],
            newMaintenance: false,
            photoNag: false,
            loading: false,
            fullScreen: false,
            fullScreenIndex: 0,
            zoomFactor: .6,
            canZoom: false,
            confirmDelete: false,
            confirmReject: false,
            confirmApprove: false,
            ReviewedDate: null,
            ReviewedBy: null,
            ReviewStatusTypeId: 1,
            ReviewComments: null,
            ReviewerName: null,
            editReview: false,
            viewFile: false,
            filePath: null,
            fileName: null,
            openMaintenance: {}
        }

        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleKeyStroke = this.handleKeyStroke.bind(this)
        this.handleMouseWheel = this.handleMouseWheel.bind(this)
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        this.getBrowserType()
        this.refreshMaintenanceTypeList()
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('keyup', this.handleKeyStroke)
        document.addEventListener('wheel', this.handleMouseWheel)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('keyup', this.handleKeyStroke);
        document.removeEventListener('wheel', this.handleMouseWheel);
    }

    getBrowserType = () => {
        if (navigator.userAgent.indexOf("Firefox") !== -1) {
            this.setState({ isChrome: false })
        }
    }

    setEventType = (eventType: string) => {
        this.setState({ eventType: eventType })
    }

    handleChange = (event: any) => {
        let temp: any = this.state
        temp[this.state.eventType] = event.target.value
        this.setState(temp)
        this.updatePostParams()
    }

    handleClickOutside = (event: { target: any }) => {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target) && this.state.fullScreen) {
            this.toggleFullScreen([], 0)
            this.simulateCardClick(this.state.maintenanceDex)
        }
    }

    handleKeyStroke = (event: { target: any, key: any }) => {
        if (event.key === "Escape") {
            this.toggleFullScreen([], 0)
            this.simulateCardClick(this.state.maintenanceDex)
        }
    }

    handleMouseWheel = (event: any) => {
        if (this.state.canZoom) {
            if (event.deltaY < 0 && this.state.zoomFactor < 2) {
                this.setState({ zoomFactor: this.state.zoomFactor + .2 })
            }
            if (event.deltaY > 0 && this.state.zoomFactor >= .8) {
                this.setState({ zoomFactor: this.state.zoomFactor - .2 })
            }
        }
    }

    refreshMaintenanceTypeList = () => {
        if (this.props.fleetReference.vehicleMaintenanceTypes) {
            let temp = []
            for (let i = 0; i < this.props.fleetReference.vehicleMaintenanceTypes.length; i++) {
                temp.push(this.props.fleetReference.vehicleMaintenanceTypes[i])
                temp[i].checked = false
            }
            this.setState({ maintenanceTypeList: temp })
            this.serviceParams = []
        }
    }

    openMaintenanceItem = (id: string, index: number) => {
        this.refreshMaintenanceTypeList()
        if (index !== this.state.expandLess) {
            this.setState(
                {
                    expandLess: index,
                    maintenanceId: id,
                    maintenanceDex: index,
                    maintenanceDate: this.props.maintenances[index].MaintenanceDate,
                    Mileage: this.props.maintenances[index].Mileage,
                    PerformedBy: this.props.maintenances[index].PerformedBy,
                    ReviewComments: this.props.maintenances[index].ReviewComments,
                    ReviewStatusTypeId: this.props.maintenances[index].ReviewStatusTypeId,
                    ReviewedBy: this.props.maintenances[index].ReviewedBy,
                    ReviewedDate: this.props.maintenances[index].ReviewedDate,
                    ReviewerName: this.props.maintenances[index].ReviewerName
                }
            )
            this.getServicePerformed(id)
            this.getMaintenanceReceipts(id)
            this.scroll(index)
        }
        else {
            this.setState({ expandLess: -1 })
        }
    }

    getMaintenanceReceipts = (id: string) => {
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/getMaintenanceImagesByMaintId/" + id, AxiosConfig.configValue())
            .then(res => {
                this.setState({ maintenanceReceipts: res.data.vehicleMaintenanceReceipts })
            }).catch(err => {
                //console.log(err)
            })
    }

    getServicePerformed = (id: string) => {
        this.setState({ loading: true })
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/getMaintenanceByMaintenanceId/" + id, AxiosConfig.configValue())
            .then(res => {
                this.setState({ Comments: res.data.vehicleMaintenance.Comments || "", loading: false, openMaintenance: res.data.vehicleMaintenance })
                this.populateServicesPerformed(res.data.servicesPerformed)
            }).catch(err => {
                //console.log(err)
            })
    }

    updateMainenanceItems = () => {
        this.updatePostParams()
        this.createOrUpdateMaintenancePost(false)
        this.createOrUpdateServicesPerformedPost(false)
    }

    addnewMaintenance = () => {
        this.updatePostParams()
        this.createOrUpdateMaintenancePost(true)
    }

    deleteMaintenanceItem = (args: string) => {
        if (args === "yes") {
            this.updatePostParams()
            const keys = Object.keys(this.postParams)
            for (let i = 0; i < keys.length; i++) {
                this.postParams[keys[i]] = this.state.openMaintenance[keys[i]]
            }
            this.postParams.DeletedBy = this.props.userId
            this.postParams.DeletedDate = moment().format()
            this.createOrUpdateMaintenancePost(false)
            this.toggleConfirmDelete()
            this.props.refreshAll("maintenance")
            snackBar({ text: "Maintenance Record Deleted", type: "error", timeout: 3000 })
        } else {
            this.toggleConfirmDelete()
        }
    }

    reviewMaintenanceItem = (ReviewStatusTypeId: number) => {
        this.updatePostParams()
        const date = moment().format()
        const keys = Object.keys(this.postParams)
        for (let i = 0; i < keys.length; i++) {
            this.postParams[keys[i]] = this.state.openMaintenance[keys[i]]
        }
        this.postParams.ModifiedBy = this.props.userId
        this.postParams.ModifyDate = date
        this.postParams.ReviewedBy = this.props.userId
        this.postParams.ReviewedDate = date
        this.postParams.ReviewStatusTypeId = ReviewStatusTypeId
        this.createOrUpdateMaintenancePost(false)
        this.toggleReview()
        this.props.refreshAll("maintenance")
        if (!this.state.editReview) {
            if (ReviewStatusTypeId === 2) {
                snackBar({ text: "Maintenance Record Approved", type: "success", timeout: 3000 })
            } else {
                snackBar({ text: "Maintenance Record Rejected", type: "error", timeout: 3000 })
            }
        } else {
            snackBar({ text: "Review Updated", type: "success", timeout: 3000 })
        }
        this.setState({ editReview: false })
    }

    toggleConfirmDelete = () => {
        if (this.state.confirmDelete) {
            this.setState({ confirmDelete: false })
        } else {
            this.setState({ confirmDelete: true })
        }
    }

    photoNag = () => {
        if (this.state.photoNag) {
            this.setState({ photoNag: false, newMaintenance: false })
        } else {
            this.setState({ photoNag: true, newMaintenance: false })

        }
    }

    toggleReview = (key?: string) => {
        if (key) {
            let temp: any = this.state
            if (temp[key]) {
                temp[key] = false
            } else {
                temp[key] = true
            }
            this.setState(temp)
        }
        else {
            this.setState({ confirmApprove: false, confirmReject: false })
        }
    }
    toggleEditReview = () => {
        if (this.state.editReview) {
            this.setState({ editReview: false })
        } else {
            this.setState({ editReview: true })
        }
    }

    confirmNewMaintenance = (args: string) => {
        if (args === "yes") {
            this.setState({ maintenanceDex: -1 })
            this.toggleNewRecieptView()
            this.photoNag()
            snackBar({ text: "Maintenance Record Added", type: "success", timeout: 3000 })
        }
        if (args === "no") {
            this.props.refreshAll("maintenance")
            this.toggleNewMaintenanceView()
            this.photoNag()
            snackBar({ text: "Maintenance Record Added", type: "success", timeout: 3000 })
        }
    }

    createOrUpdateServicesPerformedPost = (isNew: boolean) => {
        this.setState({ loading: true })
        if (this.serviceParams.length > 0) {
            for (let i = 0; i < this.serviceParams.length; i++) {
                this.serviceParams[i].VehicleMaintenanceId = this.state.maintenanceId
                let requestBody = this.serviceParams[i]
                axios.post(process.env.REACT_APP_API_URL + "/api/Fleet/CreateOrUpdateServicesPerformedPost", requestBody, AxiosConfig.configValue("min"))
                    .then(res => {
                        this.setState({ loading: false })
                        if (i === this.serviceParams.length - 1) {
                            if (isNew) {
                                this.photoNag()
                                snackBar({ text: "Maintenance record created", type: "success", timeout: 3000 })
                            } else {
                                this.props.refreshAll("maintenance")
                                snackBar({ text: "Maintenance record updated", type: "success", timeout: 3000 })
                            }
                        }
                    })
                    .catch(err => {
                        //console.log(err, err.response);
                        AxiosConfig.handleError(err);
                        snackBar({ text: "Failed to update maintenance record", type: "error", timeout: 3000 })
                        this.setState({ loading: false })
                    })
            }
        }
    }

    createOrUpdateMaintenancePost = (isNew: boolean) => {
        let requestBody = this.postParams
        if (isNew) {
            requestBody.ReviewStatusTypeId = 1
            requestBody.ReviewedDate = null
            requestBody.ReviewedBy = null
            requestBody.ReviewComments = null
        }
        axios.post(process.env.REACT_APP_API_URL + "/api/Fleet/CreateOrUpdateMaintenancePost", requestBody, AxiosConfig.configValue("min"))
            .then(res => {
                // let card = document.getElementById("vm-toggle-" + this.state.maintenanceDex)
                // if (card && !isNew) {
                //     card.click()
                // }
                if (!isNew) {
                    this.props.refreshAll("maintenance")
                } else {
                    this.setState({ maintenanceId: res.data.VehicleMaintenanceId })
                    this.updatePostParams()
                    this.createOrUpdateServicesPerformedPost(true)
                    let warningIconWrapper = document.getElementById(`vehicle-table-warning-icons-${this.props.details.VehicleNumber}`)
                    if (warningIconWrapper) {
                        warningIconWrapper.innerHTML += `<span id="${this.props.details.VehicleNumber}-maintenance-wating-review" class="material-icons fleet-cell-waiting-maintenance-review">build</span>`
                    }
                }
                if (this.props.updateNotiication) {
                    this.props.updateNotiication(true)
                }
            })
            .catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    populateServicesPerformed = (servicesPerformed: Array<any>) => {
        for (let i = 0; i < servicesPerformed.length; i++) {
            for (let j = 0; j < this.state.maintenanceTypeList.length; j++) {
                if (servicesPerformed[i].VehicleMaintenanceTypeId === this.state.maintenanceTypeList[j].id) {
                    let temp = this.state.maintenanceTypeList
                    temp[j].ServicesPerformedId = servicesPerformed[i].ServicesPerformedId
                    this.appendServiceParams(temp[j], j, true)
                }
            }
        }
    }

    appendServiceParams = (maintenanceItem: any, index: number, checked: boolean) => {

        let paramBody =
        {
            ServicesPerformedId: maintenanceItem.ServicesPerformedId || "",
            VehicleMaintenanceId: this.state.maintenanceId,
            VehicleMaintenanceTypeId: "",
            CreatedDate: moment().format(),
            CreatedBy: this.props.userId,
            ModifyDate: moment().format(),
            ModifiedBy: this.props.userId,
            DeletedDate: "",
            DeletedBy: "",
            DisabledDate: "",
            DisabledBy: ""

        }
        let temp = this.state.maintenanceTypeList
        temp[index].checked = checked
        this.setState({ maintenanceTypeList: temp })
        if (checked) {
            paramBody.VehicleMaintenanceTypeId = maintenanceItem.id + ""
        } else {
            paramBody.DeletedDate = moment().format()
            paramBody.DeletedBy = this.props.userId
        }
        this.serviceParams.push(paramBody)
    }

    updatePostParams = () => {
        let paramBody =
        {
            VehicleMaintenanceId: this.state.maintenanceId || "",
            VehicleInformationId: this.props.details.VehicleInformationId,
            MaintenanceDate: this.state.maintenanceDate,
            MaintenanceById: this.props.userId,
            Mileage: this.state.Mileage,
            PerformedBy: this.state.PerformedBy,
            PurchaseOrderNumber: this.state.PurchaseOrderNumber,
            Comments: this.state.Comments,
            CreatedDate: moment().format(),
            CreatedBy: this.props.userId,
            ModifyDate: moment().format(),
            ModifiedBy: this.props.userId,
            DeletedDate: null,
            DeletedBy: null,
            DisabledDate: null,
            DisabledBy: null,
            ReviewedDate: this.state.ReviewedDate,
            ReviewedBy: this.state.ReviewedBy,
            ReviewStatusTypeId: this.state.ReviewStatusTypeId,
            ReviewComments: this.state.ReviewComments
        }
        this.postParams = paramBody
    }

    handleMaintenanceDate = (val: number) => {
        this.setState({ maintenanceDate: moment(val.valueOf()).format() })
    }

    toggleNewRecieptView = () => {
        if (this.state.attachments) {
            this.setState({ attachments: false })
            this.getMaintenanceReceipts(this.props.maintenances[this.state.maintenanceDex].VehicleMaintenanceId)
        } else {
            this.setState({ attachments: true })
        }
    }

    toggleNewMaintenanceView = () => {
        if (this.state.newMaintenance) {
            this.setState({ newMaintenance: false })
        } else {
            let openCard = document.getElementById("vm-toggle-" + this.state.maintenanceDex)
            if (openCard && this.state.expandLess > -1) {
                openCard.click()
            }
            this.setState({
                newMaintenance: true,
                maintenanceTypeList: [],
                maintenanceId: "",
                maintenanceDate: "",
                Mileage: 0,
                PerformedBy: "",
                PurchaseOrderNumber: "",
                Comments: "",
            })
            this.refreshMaintenanceTypeList()
        }
    }

    toggleZoom = (args: string) => {
        if (args === "off") {
            this.setState({ canZoom: false })
        } else {
            this.setState({ canZoom: true })
        }
    }

    toggleFullScreen = (pics: any, index: number) => {
        if (pics.length === 0) {
            this.setState({ fullScreen: false })
        } else {
            this.simulateCardClick(this.state.maintenanceDex)
            let temp = []
            for (let i = 0; i < pics.length; i++) {
                temp.push(pics.img)
            }
            this.setState({ fullScreen: true, maintenanceReceipts: pics, fullScreenIndex: index })
            snackBar({ text: "Press ESCAPE to exit", type: "plain", timeout: 1500 })
        }
    }

    fullScreenPan = (direction: string) => {
        if (direction === '-') {
            this.fullScreenIndex -= 1
            if (this.fullScreenIndex < 0) {
                this.fullScreenIndex = this.state.maintenanceReceipts.length - 1
            }
        } else {
            this.fullScreenIndex += 1
            if (this.fullScreenIndex > this.state.maintenanceReceipts.length - 1) {
                this.fullScreenIndex = 0
            }
        }
        const isImage = this.isImage(reggie.getFileExtensionFromString(this.state.maintenanceReceipts[this.fullScreenIndex].RelativePath)) || false
        if (!isImage) {
            this.fullScreenPan(direction)
        } else {
            this.setState({ fullScreenIndex: this.fullScreenIndex })
        }
    }

    simulateCardClick = (cardDex: number) => {
        document.getElementById("vm-toggle-" + cardDex)?.click()
    }

    scroll = (index: number) => {
        try {
            let item: any = document.getElementById("vm-toggle-" + index)
            item.scrollIntoView({ behavior: "smooth", block: "start", })
        } catch (error) {
            //console.log(error)
        }
    }

    toggleViewFile = (path: string, name: string) => {
        this.setState({ viewFile: !this.state.viewFile, filePath: path, fileName: name })
    }

    isImage = (extension: string | null) => {
        const extensions = this.imageExtensions
        if (extension && extensions.includes(extension)) {
            return true
        }
        return
    }

    render() {

        // //console.log("props: ", this.props)
        // //console.log("state: ", this.state)
        // //console.log("service params: ", this.serviceParams)
        // //console.log("post params: ", this.postParams)
        // //console.log("maintenance id: " + this.state.maintenanceId)

        let maintenances = this.props.maintenances
        let reviewStatus = 1

        if (maintenances[this.state.maintenanceDex]) {
            reviewStatus = maintenances[this.state.maintenanceDex].ReviewStatusTypeId
        }

        if (this.props.fleetReference) {
            for (let i = 0; i < maintenances.length; i++) {
                for (let j = 0; j < this.props.fleetReference.logos.length; j++) {
                    let a = maintenances[i].PerformedBy && maintenances[i].PerformedBy.toLowerCase().split(" ").join("")
                    let b = this.props.fleetReference.logos[j].performedBy.toLowerCase()
                    if (a && a.includes(b)) {
                        maintenances[i].logo = this.props.fleetReference.logos[j].logo
                    }
                    if (!a) {
                        maintenances[i].logo = "none"
                    }
                }
            }
        }

        const tooltip = (text: string) => (
            <Tooltip id="vi-pin-tooltip">
                {text}
            </Tooltip>
        )

        const popover = (text: string) => {
            if (text && text.trim() !== "") {
                return (
                    <Popover id="popover-basic">
                        <Popover.Title as="h3">Reviewer Comments</Popover.Title>
                        <Popover.Content>
                            {text}
                        </Popover.Content>
                    </Popover>
                )
            }
            return (
                tooltip("No Comments")
            )
        }

        return (
            <div className="VehicleMaintenance">

                {!this.state.newMaintenance && !this.state.attachments && <OverlayTrigger trigger={["hover", "focus"]} placement="auto-start" delay={0} overlay={tooltip("Add a new maintenance record")}>
                    <div className="NewInspectionBtn">
                        <span className="material-icons" onClick={() => this.toggleNewMaintenanceView()}>add</span>
                    </div>
                </OverlayTrigger>}

                {this.state.viewFile && <DocViewer
                    fileName={this.state.filePath}
                    //@ts-ignore
                    extension={reggie.getFileExtensionFromString(this.state.filePath)}
                    toggleDocViewer={() => this.toggleViewFile("", "")}
                    displayName={this.state.fileName || "Unnamed"}
                    containerName={this.containerName || ""}
                    storageLocation={this.storageLocation || ""}
                />}
                {this.state.attachments && <DocUploader
                    toggleDocUploader={() => this.toggleNewRecieptView()}
                    maintenanceID={this.state.maintenanceId}
                    contextUserId={this.props.userId}
                    refreshTimeline={() => null}
                    storageLocation={this.storageLocation || ""}
                    containerName={this.containerName || ""}
                    fileStoreLocationId={this.fileStoreLocationId || ""}
                />}
                {this.state.photoNag &&
                    <Modal id="fleet-photo-nag-modal"
                        show={true}
                        backdrop="static"
                        keyboard={true}
                    >
                        <Modal.Header>
                            <Modal.Title>Add Receipt Photos?</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <Button onClick={() => this.confirmNewMaintenance("yes")}>Yes</Button>
                            <Button onClick={() => this.confirmNewMaintenance("no")}>No</Button>
                        </Modal.Footer>
                    </Modal>}
                {this.state.confirmDelete &&
                    <Modal id="fleet-photo-nag-modal"
                        show={true}
                        backdrop="static"
                        keyboard={true}
                    >
                        <Modal.Header>
                            <Modal.Title>Are you sure you want to delete this maintenace record?</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <div className="VM-Delete-Record-Wrapper">
                                <Button id="vm-delete-record-delete" variant="danger" onClick={() => this.deleteMaintenanceItem("yes")}>Delete</Button>
                                <Button id="vm-delete-record-cancel" variant="secondary" onClick={() => this.deleteMaintenanceItem("no")}>Cancel</Button>
                            </div>
                        </Modal.Footer>
                    </Modal>}
                {this.state.newMaintenance &&
                    <Modal id="fleet-photo-modal"
                        show={true}
                        backdrop="static"
                        keyboard={true}
                        size="lg"
                    >
                        <Modal.Header>
                            <Modal.Title>New Maintenance Record</Modal.Title>
                        </Modal.Header>
                        <NewMaintenance
                            maintenanceTypeList={this.state.maintenanceTypeList}
                            isChrome={this.state.isChrome}
                            appendServiceParams={this.appendServiceParams}
                            handleMaintenanceDate={this.handleMaintenanceDate}
                            maintenanceDate={this.state.maintenanceDate}
                            setEventType={this.setEventType}
                            Mileage={this.state.Mileage}
                            handleChange={this.handleChange}
                            PerformedBy={this.state.PerformedBy}
                            PurchaseOrderNumber={this.state.PurchaseOrderNumber}
                            Comments={this.state.Comments}
                            toggleNewRecieptView={this.toggleNewRecieptView}
                            addNewMaintenance={this.addnewMaintenance}
                            serviceParams={this.serviceParams}
                            toggleNewMaintenanceView={this.toggleNewMaintenanceView}
                        />
                    </Modal>}
                {this.state.editReview &&
                    <Modal
                        show={true}
                        backdrop="static"
                        keyboard={true}
                    >
                        <Modal.Header>
                            <Modal.Title>Edit Review Comments</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FormControl
                                onFocus={() => this.setEventType("ReviewComments")}
                                as="textarea"
                                rows={4}
                                placeholder={"Comments"}
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.state.ReviewComments || ""}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="Edit-Maintenace-Review-Comments-Footer">
                                <Button variant="secondary" id="edit-maintenace-review-comments-footer-cancel" onClick={() => this.toggleEditReview()}>Cancel</Button>
                                {this.state.ReviewComments && <Button id="edit-maintenace-review-comments-footer-save" onClick={() => this.reviewMaintenanceItem(maintenances[this.state.maintenanceDex].ReviewStatusTypeId)}>Save</Button>}
                            </div>
                        </Modal.Footer>
                    </Modal>}
                {this.state.confirmApprove &&
                    <Modal
                        show={true}
                        backdrop="static"
                        keyboard={true}
                    >
                        <Modal.Header>
                            <Modal.Title>Approve this maintenance item?</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FormControl
                                onFocus={() => this.setEventType("ReviewComments")}
                                as="textarea"
                                rows={4}
                                placeholder={"Comments"}
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.state.ReviewComments || ""}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="VM-Review-Modal-Footer">
                                <Button variant="secondary" onClick={() => this.toggleReview("confirmApprove")}>Cancel</Button>
                                <Button variant="success" onClick={() => this.reviewMaintenanceItem(2)}>Approve</Button>
                            </div>
                        </Modal.Footer>
                    </Modal>}
                {this.state.confirmReject &&
                    <Modal
                        show={true}
                        backdrop="static"
                        keyboard={true}
                    >
                        <Modal.Header>
                            <Modal.Title>Reject this maintenance item?</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FormControl
                                onFocus={() => this.setEventType("ReviewComments")}
                                as="textarea"
                                rows={4}
                                placeholder={"Comments"}
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.state.ReviewComments || ""}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="VM-Review-Modal-Footer">
                                <Button variant="secondary" onClick={() => this.toggleReview("confirmReject")}>Cancel</Button>
                                <Button variant="danger" onClick={() => this.reviewMaintenanceItem(3)}>Reject</Button>
                            </div>
                        </Modal.Footer>
                    </Modal>}
                {this.state.fullScreen && this.state.maintenanceReceipts.length > 0 && <div className="VIFullScreenCarousel">
                    <div className="VI-FullScreen-Exit-Dummy-Btn-Wrapper">
                        <span className="material-icons">close</span>
                    </div>
                    <div className="VI-Fullscreen-Img-Wrapper" ref={this.wrapperRef} onMouseEnter={() => this.toggleZoom("on")} onMouseLeave={() => this.toggleZoom("off")}>
                        <div className="VI-FullScreen-Pan-Left" onClick={() => this.fullScreenPan("-")}>
                            <span className="material-icons">keyboard_arrow_left</span>
                        </div>
                        {/* {this.isImage(reggie.getFileExtensionFromString(this.state.maintenanceReceipts[this.state.fullScreenIndex].RelativePath)) && <Magnifier src={this.state.maintenanceReceipts[this.state.fullScreenIndex].ImageFullUrl} mgWidth={200} mgHeight={200} zoomFactor={this.state.zoomFactor} mgShowOverflow={false} />} */}
                        {/*!!r-18-bk*/}
                        {/*@ts-ignore*/}
                        <Magnifier src={this.state.maintenanceReceipts[this.state.fullScreenIndex].ImageFullUrl} mgWidth={200} mgHeight={200} zoomFactor={this.state.zoomFactor} mgShowOverflow={false} />
                        <div className="VI-FullScreen-Pan-Right" onClick={() => this.fullScreenPan("+")}>
                            <span className="material-icons">keyboard_arrow_right</span>
                        </div>
                    </div>
                </div>}
                {!this.state.fullScreen && <div className="Vehicle-Maintenance-List">
                    <Accordion>
                        {maintenances.length > 0 && maintenances.map((maintenance: any, i: number) =>
                            <div key={i}>
                                <Card key={i}>
                                    <Accordion.Toggle as={Card.Header} eventKey={i + ""} id={"vm-toggle-" + i} onClick={() => this.openMaintenanceItem(maintenance.VehicleMaintenanceId, i)}>
                                        <div className="VM-Card">
                                            <div className="Vm-Card-C1">
                                                <div className="Vm-Card-C1-Inspection-Status">
                                                    {!maintenance.ReviewStatusTypeId && <div className="Vm-Card-C1-Inspection-Unsure">
                                                        <span className="material-icons">build</span>
                                                    </div>}
                                                    {maintenance.ReviewStatusTypeId === 1 && <div className="Vm-Card-C1-Inspection-Waiting">
                                                        <span className="material-icons">build</span>
                                                    </div>}
                                                    {maintenance.ReviewStatusTypeId === 2 && <div className="Vm-Card-C1-Inspection-Approved">
                                                        <span className="material-icons">done</span>
                                                    </div>}
                                                    {maintenance.ReviewStatusTypeId === 3 && <div className="Vm-Card-C1-Inspection-Rejected">
                                                        <span className="material-icons">close</span>
                                                    </div>}
                                                </div>
                                                {/* <span className="material-icons" id="vm-card-maintenance-date-span">event</span> */}
                                                {maintenance.MaintenanceDate && <p id="vm-card-maintenance-date">{moment().format(maintenance.MaintenanceDate).split("T")[0]}</p>}
                                                {maintenance.Mileage && <p id="vm-card-vehicle-mileage">{"Miles: " + maintenance.Mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>}
                                            </div>
                                            <div className="Vm-Card-C2">
                                                {!maintenance.logo && <span id="vm-card-no-logo" className="material-icons">build</span>}
                                                {!maintenance.logo && <p id="vm-card-performed-by">{maintenance.PerformedBy}</p>}
                                                {maintenance.logo && maintenance.logo !== "none" && <img id="vm-maintenance-shop-logo" src={maintenance.logo} alt=""></img>}
                                                {maintenance.logo && maintenance.logo !== "none" && <p id="maintenance-preformed-by-descriptor">{maintenance.PerformedBy}</p>}
                                                {maintenance.logo && maintenance.logo === "none" && <span id="vm-maintenance-shop-no-info" className="material-icons">report_problem</span>}
                                                {maintenance.logo && maintenance.logo === "none" && <p id="maintenance-preformed-by-descriptor">Not Listed</p>}
                                                <p>- {maintenance.MaintenanceList}</p>
                                            </div>
                                            <div className="Vm-Card-C3">
                                                {maintenance.ReviewStatusTypeId === 1 && <div>
                                                    <p>Waiting Review</p>
                                                </div>}
                                                {maintenance.ReviewStatusTypeId === 2 && <div>
                                                    <p>Approved by {maintenance.ReviewerName}</p>
                                                </div>}
                                                {maintenance.ReviewStatusTypeId === 3 && <div>
                                                    <p>Rejected by {maintenance.ReviewerName}</p>
                                                </div>}
                                            </div>
                                            <div className="Vm-Card-C4">
                                                <span className="material-icons" id="maintenance-card-avatar">person</span>
                                                <p>{maintenance.MaintenanceBy}</p>
                                            </div>
                                        </div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={i + ""}>
                                        <div className="VM-Collapse">
                                            <div className="VM-Collapse-Columns" id="vm-collapse-columns">
                                                <div className="VM-Collapse-C1">
                                                    {this.state.loading && <div className="VM-Collapse-Spinner">
                                                        <Spinner animation="border" />
                                                    </div>}
                                                    <div className="Vehicle-Maintenance-Service-Types-Wrapper">
                                                        {this.state.maintenanceTypeList.length > 0 && this.state.maintenanceTypeList.map((maintenanceItem, i) =>
                                                            <div key={"vehcile-maintenance-services-type-" + maintenanceItem.id}>
                                                                {!maintenanceItem.checked && <Button onClick={() => this.appendServiceParams(maintenanceItem, i, true)}>
                                                                    <div id="vehicle-maintenance-service-type-btn">
                                                                        {this.state.isChrome && <input id="fleet-chrome-radio" type="checkbox" onClick={() => this.appendServiceParams(maintenanceItem, i, true)}></input>}
                                                                        {!this.state.isChrome && <input id="fleet-fox-radio" type="checkbox" onClick={() => this.appendServiceParams(maintenanceItem, i, true)}></input>}
                                                                        <p>{maintenanceItem.text}</p>
                                                                    </div>
                                                                </Button>}
                                                                {maintenanceItem.checked && <Button id="vas-ranges-clear" onClick={() => this.appendServiceParams(maintenanceItem, i, false)}>
                                                                    <div id="vehicle-maintenance-service-type-btn">
                                                                        {this.state.isChrome && <input id="fleet-chrome-radio" type="checkbox" defaultChecked onClick={() => this.appendServiceParams(maintenanceItem, i, false)}></input>}
                                                                        {!this.state.isChrome && <input id="fleet-fox-radio" type="checkbox" defaultChecked onClick={() => this.appendServiceParams(maintenanceItem, i, false)}></input>}
                                                                        <p>{maintenanceItem.text}</p>
                                                                    </div>
                                                                </Button>}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="VM-Collapse-C2">
                                                    <p>Maintenance Date</p>
                                                    <DatePicker value={this.state.maintenanceDate || ""} onChange={this.handleMaintenanceDate} type="input" useCloseCallback />
                                                    <p>Mileage</p>
                                                    <FormControl
                                                        onFocus={() => this.setEventType("Mileage")}
                                                        placeholder={this.state.Mileage + "" || "Vehicle Mileage"}
                                                        aria-describedby="basic-addon1"
                                                        onChange={this.handleChange}
                                                        value={this.state.Mileage || ""}
                                                    />
                                                    <p>Business Performing Work</p>
                                                    <FormControl
                                                        onFocus={() => this.setEventType("PerformedBy")}
                                                        placeholder={this.state.PerformedBy + "" || "Performed By"}
                                                        aria-describedby="basic-addon1"
                                                        onChange={this.handleChange}
                                                        value={this.state.PerformedBy || ""}
                                                    />
                                                    <p>Purchase Order Number</p>
                                                    <FormControl
                                                        onFocus={() => this.setEventType("PurchaseOrderNumber")}
                                                        placeholder={this.state.PurchaseOrderNumber + "" || "Order #"}
                                                        aria-describedby="basic-addon1"
                                                        onChange={this.handleChange}
                                                        value={this.state.PurchaseOrderNumber || ""}
                                                    />
                                                </div>
                                                <div className="VM-Collapse-C3">
                                                    {(reviewStatus !== 2 && reviewStatus !== 3) && shouldAllowAccess("FLEET:MA") && this.props.maintenances[this.state.maintenanceDex]?.MaintenanceById && (this.props.maintenances[this.state.maintenanceDex]?.MaintenanceById.toString() !== this.props.userId) && <div className="VM-Collapse-C3-Review">
                                                        <div id="vm-collapse-c3-review-btn-approve" className="VM-Collapse-C3-Review-Btn" onClick={() => this.toggleReview("confirmApprove")}>
                                                            <span className="material-icons">done</span>
                                                            <p>Approve</p>
                                                        </div>
                                                        <div id="vm-collapse-c3-review-btn-reject" className="VM-Collapse-C3-Review-Btn" onClick={() => this.toggleReview("confirmReject")}>
                                                            <span className="material-icons">cancel</span>
                                                            <p>Reject</p>
                                                        </div>
                                                    </div>}
                                                    {(reviewStatus === 2 || reviewStatus === 3) && <div className="VM-Collapse-C3-Review-Status">
                                                        <div className="VM-Collapse-C3-Review-Status-Comments">
                                                            <OverlayTrigger trigger={["hover", "focus"]} placement="auto-start" delay={0} overlay={tooltip("Edit Review Comments")}>
                                                                <span className="material-icons" onClick={() => this.toggleEditReview()}>create</span>
                                                            </OverlayTrigger>
                                                        </div>
                                                        <div className="VM-Collapse-C3-Review-Status-View-Comments">
                                                            <OverlayTrigger trigger={["hover", "focus"]} placement="auto-start" delay={0} overlay={popover(maintenances[this.state.maintenanceDex].ReviewComments)}>
                                                                <span className="material-icons">chat</span>
                                                            </OverlayTrigger>
                                                        </div>
                                                        {reviewStatus === 2 &&
                                                            <OverlayTrigger trigger={["hover", "focus"]} placement="auto-start" delay={0} overlay={tooltip(moment(maintenances[this.state.maintenanceDex].ReviewedDate).format("YYYY[-]MM[-]DD"))}>
                                                                <div className="VM-Collapse-C3-Review-Status-Approved">
                                                                    <span className="material-icons">done</span>
                                                                    {maintenances[this.state.maintenanceDex].ReviewerName && <p>Approved by {maintenances[this.state.maintenanceDex].ReviewerName}</p>}
                                                                    {!maintenances[this.state.maintenanceDex].ReviewerName && <p>Approved</p>}
                                                                </div>
                                                            </OverlayTrigger>}
                                                        {reviewStatus === 3 &&
                                                            <OverlayTrigger trigger={["hover", "focus"]} placement="auto-start" delay={0} overlay={tooltip(moment(maintenances[this.state.maintenanceDex].ReviewedDate).format("YYYY[-]MM[-]DD"))}>
                                                                <div className="VM-Collapse-C3-Review-Status-Rejected">
                                                                    <span className="material-icons">cancel</span>
                                                                    {maintenances[this.state.maintenanceDex].ReviewerName && <p>Rejected by {maintenances[this.state.maintenanceDex].ReviewerName}</p>}
                                                                    {!maintenances[this.state.maintenanceDex].ReviewerName && <p>Rejected</p>}
                                                                </div>
                                                            </OverlayTrigger>}
                                                    </div>}
                                                    <p>Employee Comments</p>
                                                    <FormControl
                                                        as="textarea"
                                                        rows={4}
                                                        onFocus={() => this.setEventType("Comments")}
                                                        placeholder={this.state.Comments + "" || "Comments"}
                                                        aria-describedby="basic-addon1"
                                                        onChange={this.handleChange}
                                                        value={this.state.Comments || ""}
                                                    />
                                                    <div className="VM-Attach-Receipts-Wrapper">
                                                        <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={tooltip("Attach receipts")}>
                                                            <span className="material-icons" onClick={() => this.toggleNewRecieptView()}>attach_file</span>
                                                        </OverlayTrigger>
                                                    </div>
                                                    <div className="VM-Card-Receipt-Pics">
                                                        {this.state.maintenanceReceipts.length > 0 && this.state.maintenanceReceipts.map((receipt: any, i: number) => <div id="vm-card-receipt-pic" key={"vm-card-receipt-pic" + i}>
                                                            {this.isImage(reggie.getFileExtensionFromString(receipt.RelativePath)) &&
                                                                <img src={receipt.ImageFullUrl} alt="" onClick={() => this.toggleFullScreen(this.state.maintenanceReceipts, i)}></img>}
                                                            {!this.isImage(reggie.getFileExtensionFromString(receipt.RelativePath)) &&
                                                                <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={tooltip(receipt.Name)}>
                                                                    <div onClick={() => this.toggleViewFile(receipt.RelativePath, receipt.Name)}>
                                                                        <IconBuilder
                                                                            //@ts-ignore
                                                                            extension={reggie.getFileExtensionFromString(receipt.RelativePath)}
                                                                            size={64}
                                                                        />
                                                                    </div>
                                                                </OverlayTrigger>}
                                                        </div>)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="VM-Card-Footer">
                                                {!this.state.loading && <Button id="vm-save-btn" variant="danger" onClick={() => this.toggleConfirmDelete()}>Delete</Button>}
                                                {!this.state.loading && <Button id="vm-save-btn" onClick={() => this.updateMainenanceItems()}>Save</Button>}
                                            </div>
                                        </div>
                                    </Accordion.Collapse>
                                    {this.state.expandLess === i && <div className="Maintenance-Expand-Icon-Wrapper" onClick={() => this.simulateCardClick(i)}>
                                        <span className="material-icons">expand_less</span>
                                    </div>}
                                    {this.state.expandLess !== i && <div className="Maintenance-Expand-Icon-Wrapper" onClick={() => this.simulateCardClick(i)}>
                                        <span className="material-icons">expand_more</span>
                                    </div>}
                                </Card>
                            </div>
                        )}
                    </Accordion>
                </div >}
            </div>
        )
    }
}

export default VehicleMaintenance